import React, { useState } from "react";
import "../../css/stickyMenu.css";
import { NavLink } from "react-router-dom";

function StickyExploreButton({showItem = [], stickyTheme}){
    const [expandStickyButton, setExpandStickyButton] = useState(false);

    const exploreItems = [
        {
            'title' : 'T-CARE',
            'image' : '/assets/sticky_icon/Icon_T-CARE.png',
            'body' : 'T-CARE: Bebas biaya servis 7x + Extended Warranty',
            'url' : '/t-care'
        },
        {
            'title' : 'Hybrid Health Check',
            'image' : '/assets/sticky_icon/Icon_Hybrid_Health_Check.png',
            'body' : 'Hybrid Health Check: Cek baterai gratis',
            'url' : '/hybrid-health-check'
        },
        {
            'title' : 'T-OPT',
            'image' : '/assets/sticky_icon/Icon_T-OPT.png',
            'body' : 'T-OPT: Sparepart Terjangkau Kualitas Terpercaya',
            'url' : '/products/t-opt'
        },
        {
            'title' : 'TMO',
            'image' : '/assets/sticky_icon/Icon_TMO.png',
            'body' : 'TMO: Produk lubricants & chemical asli Toyota',
            'url' : '/products/tmo'
        },
        {
            'title' : 'Body & Paint',
            'image' : '/assets/sticky_icon/Icon_Body_Paint.png',
            'body' : 'Toyota Body & Paint: Mobil tampil maksimal',
            'url' : '/services/body-paint'
        },
        {
            'title' : 'Toyota Genuine Battery',
            'image' : '/assets/sticky_icon/Icon_Toyota_Genuine_Battery.png',
            'body' : 'Toyota Genuine Battery: Aki berkualitas dari Toyota',
            'url' : '/products/tgb'
        },
        {
            'title' : 'Tire Solution',
            'image' : '/assets/sticky_icon/Icon_Tire_Solution.png',
            'body' : 'Tire Solution: Ganti Ban Berkualitas',
            'url' : '/products/tire-solution'
        },
        {
            'title' : 'Express Maintenance',
            'image' : '/assets/sticky_icon/Icon_Express_Maintenance.png',
            'body' : 'Express Maintenance: Servis cepat 30 menit',
            'url' : '/services/express-maintenance'
        },
        {
            'title' : 'Fakta Servis',
            'image' : '/assets/sticky_icon/Icon_Service_Parts.png',
            'body' : 'Fakta Servis: Servis pintar, performa lancar',
            'url' : '/news-information'
        },
        {
            'title' : 'Mobile Service',
            'image' : '/assets/sticky_icon/Icon_Toyota_Mobile_Service.png', 
            'body' : 'Toyota Mobile Service: Servis dimana saja, kapan saja',
            'url' : '/services/toyota-mobile-service'
        },
        {
            'title' : 'Warranty',
            'image' : '/assets/sticky_icon/Icon_Warranty.png',
            'body' : 'Warranty: Garansi terjamin Toyota',
            'url' : '/warranty'
        },
    ];

    return <div id="stickyExploreButton" className={`${expandStickyButton ? 'expand' : ''}`}>
        <div id="stickyExploreHeader" className={`d-flex align-items-center justify-content-center ${stickyTheme}`}>
            <div id="stickyExploreHeaderTitle" className="d-flex align-items-center justify-content-center"
                onClick={() => {
                    window.dataLayer.push({
                        event: 'aftersales_sticky_open_click',
                        menu_section: 'aftersales_sticky_explore_menu',
                        click_detail: '[OPEN] Explore Menu',
                    });
                    // window.gtag('event', 'aftersales_menu_click', {
                    //     menu_section: 'aftersales_sticky_explore_menu',
                    //     click_detail: '[OPEN] Explore Menu',
                    // });
                    setExpandStickyButton(true)
                }}
            >
                <img src={stickyTheme == 'hybrid-theme' ? "/assets/sticky_icon/sticky_icon_2.png" : "/assets/sticky_icon/sticky_icon_1.png"} className="mx-2" height={25} />
                <span>Explore More</span>
            </div>
            <span className={`${expandStickyButton ? '' : 'd-none'}`} id="closeExploreButton"
                onClick={()=> {
                    window.dataLayer.push({
                        event: 'aftersales_sticky_close_click',
                        menu_section: 'aftersales_sticky_explore_menu',
                        click_detail: '[CLOSE] Explore Menu',
                    });
                    // window.gtag('event', 'aftersales_sticky_close_click', {
                    //     menu_section: 'aftersales_sticky_explore_menu',
                    //     click_detail: '[CLOSE] Explore Menu',
                    // });
                    setExpandStickyButton(false)
                }}
            >x</span>
        </div>
        <div id="exploreButtonContent">
            {exploreItems.filter((_, index) => showItem.includes(index)).map((item) => (
                <div>
                    <NavLink
                        to={item.url}
                        className="d-flex align-items-center"
                        onClick={() => {
                            window.dataLayer.push({
                                event: 'aftersales_sticky_open_click',
                                menu_section: 'aftersales_sticky_explore_menu',
                                click_detail: item.title,
                            });
                            // window.gtag('event', 'aftersales_menu_click', {
                            //     menu_section: 'aftersales_sticky_explore_menu',
                            //     event_feature: 'sticky_menu_click',
                            //     click_detail: item.title,
                            // });
                        }}
                    >
                        <img className="me-2" src={item.image} height={20} />
                        <p className="text-start">{item.body}</p>
                    </NavLink>
                </div>
            ))}
        </div>
    </div>
}

export default StickyExploreButton;
